import angular from 'angular';

class FirmwareLibraryService {
    firmwareColumns = [];
    firmwares = [];
    initFirmwares = [];
    releaseColumns = [];
    releaseFileColumns = [];
    releases = [];
    initReleases = [];
    deviceNames = {};

    /* @ngInject */
    constructor(ApiService, vrmNotificationsService, vrmNotificationType, locale, $rootScope) {
        this.ApiService = ApiService;
        this.vrmNotificationsService = vrmNotificationsService;
        this.vrmNotificationType = vrmNotificationType;
        this.locale = locale;
        $rootScope.$on('logout', () => {
            this.initFirmwares = null;
            this.firmwares = null;
            this.initReleases = null;
            this.releases = null;
            this.deviceNames = null;
        });
        this.locale.ready('firmware-library').then(() => {
            this.firmwareColumns = [{
                key: 'originalFileName', formatted: locale.getString('firmware-library.fileName'),
            }, {
                key: 'idProductArray', formatted: locale.getString('firmware-library.productIds'),
            }, {
                key: 'title', formatted: locale.getString('firmware-library.releaseTitleId'),
            }, {
                key: 'firmwareVersion', formatted: locale.getString('firmware-library.firmwareVersion'),
            }, {
                key: 'minVersion', formatted: locale.getString('firmware-library.minVersion'),
            }, {
                key: 'minVictronConnectVersion',
                formatted: locale.getString('firmware-library.minVictronConnectVersion'),
            }, {
                key: 'createdAt', formatted: locale.getString('firmware-library.createdAt'),
            }, {
                key: 'createdBy', formatted: locale.getString('firmware-library.createdBy'),
            }, {
                key: 'downloadUrl', formatted: locale.getString('firmware-library.downloadFirmware'),
            }];

            this.releaseColumns = [{
                key: 'title', formatted: locale.getString('firmware-library.releaseTitleId'),
            }, {
                key: 'minVersion', formatted: locale.getString('firmware-library.minVersion'),
            }, {
                key: 'minVersionSettings', formatted: locale.getString('firmware-library.minVersionSettings'),
            }, {
                key: 'minVictronConnectVersion',
                formatted: locale.getString('firmware-library.minVictronConnectVersion'),
            }, {
                key: 'createdAt', formatted: locale.getString('firmware-library.createdAt'),
            }, {
                key: 'createdByName', formatted: locale.getString('firmware-library.createdBy'),
            }];

            this.releaseFileColumns = [{
                key: 'firmwareVersion', formatted: locale.getString('firmware-library.firmwareVersion'),
            }, {
                key: 'idProductArray', formatted: locale.getString('firmware-library.productIds'),
            }, {
                key: 'downloadUrl', formatted: locale.getString('firmware-library.downloadFirmware'),
            }];
        });
    }

    async filterFirmwares(filters) {
        if (filters.size === 0) this.firmwares = this.initFirmwares;

        let filteredFirmwares = this.initFirmwares;
        for (const [key, value] of filters) {
            switch (key) {
                case "productIds":
                    filteredFirmwares = filteredFirmwares.filter((firmware) => {
                        return value.split(',').some(item => firmware.idProductArray.includes(item))
                    })
                    break;
                case "firmwareVersion":
                    filteredFirmwares = filteredFirmwares.filter((firmware) => {
                        const [min, max] = value.split(',');
                        return (!min || firmware.firmwareVersion >= min) && (!max || firmware.firmwareVersion <= max)
                    })
                    break;
                case "minVersion":
                    filteredFirmwares = filteredFirmwares.filter((firmware) => {
                        const [min, max] = value.split(',');
                        return (!min || firmware.minVersion >= min) && (!max || firmware.minVersion <= max)
                    })
                    break;
                case "minVCVersion":
                    filteredFirmwares = filteredFirmwares.filter((firmware) => {
                        const [min, max] = value.split(',');
                        return (!min || firmware.minVictronConnectVersion >= min) && (!max || firmware.minVictronConnectVersion <= max)
                    })
                    break;
                case "minVersionSettings":
                    filteredFirmwares = filteredFirmwares.filter((firmware) => {
                        const [min, max] = value.split(',');
                        return (!min || firmware.minVersionSettings >= min) && (!max || firmware.minVersionSettings <= max)
                    })
                    break;
                case "title":
                    filteredFirmwares = filteredFirmwares.filter((firmware) => {
                        return firmware.title.toLowerCase().includes(value.toLowerCase())
                    })
                    break;
                case "fileName":
                    filteredFirmwares = filteredFirmwares.filter((firmware) => {
                        return firmware.originalFileName.toLowerCase().includes(value.toLowerCase())
                    })
                    break;
                case "createdBy":
                    filteredFirmwares = filteredFirmwares.filter((firmware) => {
                        return value.split(',').some(item => firmware.createdBy === item)
                    })
                    break;
            }
        }
        this.firmwares = filteredFirmwares;
    }

    async filterReleases(filters) {
        if (filters.size === 0) this.releases = this.initReleases;

        let filteredReleases = this.initReleases;
        for (const [key, value] of filters) {
            switch (key) {
                case "productIds":
                    filteredReleases = filteredReleases.filter((release) => {
                        const releaseProductIds = new Set(release.firmwares.flatMap(firmware => firmware.idProductArray))
                        return value.split(',').some(item => releaseProductIds.has(item))
                    })
                    break;
                case "firmwareVersion":
                    filteredReleases = filteredReleases.filter((release) => {
                        const releaseFirmwareVersions = [...new Set(release.firmwares.map(firmware => firmware.firmwareVersion))]
                        const [min, max] = value.split(',');
                        return releaseFirmwareVersions.some(version => {
                            return (!min || version >= min) && (!max || version <= max)
                        })
                    })
                    break;
                case "minVersion":
                    filteredReleases = filteredReleases.filter((release) => {
                        const [min, max] = value.split(',');
                        return (!min || release.minVersion >= min) && (!max || release.minVersion <= max)
                    })
                    break;
                case "minVersionSettings":
                    filteredReleases = filteredReleases.filter((release) => {
                        const [min, max] = value.split(',');
                        return (!min || release.minVersionSettings >= min) && (!max || release.minVersionSettings <= max)
                    })
                    break;
                case "minVCVersion":
                    filteredReleases = filteredReleases.filter((release) => {
                        const [min, max] = value.split(',');
                        return (!min || release.minVictronConnectVersion >= min) && (!max || release.minVictronConnectVersion <= max)
                    })
                    break;
                case "title":
                    filteredReleases = filteredReleases.filter((release) => {
                        return release.title.toLowerCase().includes(value.toLowerCase())
                    })
                    break;
                case "createdBy":
                    filteredReleases = filteredReleases.filter((release) => {
                        return value.split(',').some(item => release.createdByName === item)
                    })
                    break;
            }
        }
        this.releases = filteredReleases;
    }

    async getReleaseData(idRelease) {
        return this.ApiService.firmwareRelease(idRelease).then(function(response) {
            if (response.data && response.data.success && response.data.releases) {
                response.data.releases[0].firmwares.forEach(firmware => {
                    const match = firmware.downloadUrl.match(/filename%3D%22(.+)%22/);
                    firmware.name = match ? match[1] : firmware.idLibrary;
                    firmware.idProducts = firmware.idProductArray;
                })
                return response.data.releases.slice(-1)[0];
            } else {
                return {};
            }
        });
    }


    async reloadFirmwares() {
        const response = await this.ApiService.firmwares();

        if (response.status !== 200) {
            this.vrmNotificationsService.add({
                type: this.vrmNotificationType.ERROR, message: 'Could not retrieve firmwares!',
            }, true);
            return null;
        }

        this.initFirmwares = response.data.firmware;
        this.initFirmwares.forEach((firmware) => firmware.title = firmware.title ? firmware.title : "Release ID: " + firmware.idRelease)
        this.firmwares = this.initFirmwares;
        const productIdArray = Array.from(
            new Set(this.initFirmwares.flatMap(firmware => firmware.idProductArray)),
        );
        const responseNames = await this.ApiService.deviceNames({"product_ids[]": productIdArray});
        if (responseNames.status === 200) {
            this.deviceNames = responseNames.data.records;
        }
        return this.firmwares;
    }

    async reloadReleases() {
        const response = await this.ApiService.firmwareRelease();

        if (response.status !== 200) {
            this.vrmNotificationsService.add({
                type: this.vrmNotificationType.ERROR, message: 'Could not retrieve firmwares!',
            }, true);
            return null;
        }

        this.initReleases = response.data.releases;
        this.initReleases.forEach((release) => release.title = release.title ? release.title : "Release ID: " + release.idRelease)
        this.releases = this.initReleases;
        const productIdArray = Array.from(
            new Set(
                this.initReleases.flatMap(release =>
                    release.firmwares.flatMap(firmware => firmware.idProductArray),
                ),
            ),
        )
        const responseNames = await this.ApiService.deviceNames({"product_ids[]": productIdArray});
        if (responseNames.status === 200) {
            this.deviceNames = responseNames.data.records;
        }
        return this.releases;
    }

    async parseFiles(files) {
        if (!files.length) return;
        const data = new FormData();
        files.forEach(function(file) {
            let fileCopy = file;
            delete fileCopy.idProducts;
            delete fileCopy.firmwareVersion;
            delete fileCopy.idLibrary;
            data.append('files[]', fileCopy);
        });
        return this.ApiService.uploadFirmwares(data);
    }
}

angular.module('vrm.core').service('FirmwareLibraryService', FirmwareLibraryService);

